<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-2" v-if="loading">
      <div class="col-sm-12 col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="mb-3">{{ $t("log.call-information") }}</h5>
            <div class="text-center">
              <div class="spinner-border text-secondary" role="status">
                <span class="sr-only">Loading..</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="mb-3">{{ $t("log.call-activity") }}</h5>
            <div class="text-center">
              <div class="spinner-border text-secondary" role="status">
                <span class="sr-only">Loading..</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2" v-if="!loading && user_type == 'superadmin'">
      <div class="col-sm-12 col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="mb-3">{{ $t("log.call-information") }}</h5>
            <div class="row">
              <div class="col-12">
                <label class="card-radio-label mb-3">
                  <div class="card-radio">
                    <span class="font-weight-bold">
                      <i class="mdi mdi-account-arrow-right mdi-24px"></i
                      >{{ $t("log.from") }}
                    </span>
                    <span class="d-inline float-right text-right">
                      {{ call.user_duid.address }} <br />
                      <strong>{{ call.profil_duid.name }} </strong>
                    </span>
                  </div>
                </label>
              </div>
              <span>
                <i class=""></i>
              </span>
              <div class="col-12">
                <label class="card-radio-label mb-3">
                  <div class="card-radio">
                    <span class="font-weight-bold">
                      <i class="mdi mdi-account-arrow-left mdi-24px"></i>
                      {{ $t("log.to") }}
                    </span>
                    <span class="d-inline float-right text-right">
                      {{ call.user_uid.address }} <br />
                      <strong>{{ call.profil_uid.name }}</strong>
                    </span>
                  </div>
                </label>
              </div>
              <div class="col-6 text-center">
                <div v-if="call.gid == 0">
                  <i class="mdi mdi-account-switch mdi-36px"></i>
                  <p class="font-weight-bolder">{{ $t("log.user-to-user") }}</p>
                </div>
                <div v-if="call.gid">
                  <i class="mdi mdi-account-group mdi-36px"></i>
                  <p class="font-weight-bolder">{{ $t("log.multi-user") }}</p>
                </div>
              </div>
              <div class="col-6 text-center">
                <div v-if="call.type == 0">
                  <i class="mdi mdi-phone mdi-36px"></i>
                  <p class="font-weight-bolder">{{ $t("log.voice-call") }}</p>
                </div>
                <div v-if="call.type == 1">
                  <i class="mdi mdi-camera mdi-36px"></i>
                  <p class="font-weight-bolder">{{ $t("log.video-call") }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-3">{{ $t("log.call-activity") }}</h5>
            <div class="row">
              <div class="col-12">
                <table class="table">
                  <tr>
                    <th>{{ $t("log.call-made") }}</th>
                    <td>{{ call.ts }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("log.ringing-on") }}</th>
                    <td>{{ call.rts }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("log.answered-on") }}</th>
                    <td>{{ call.ats }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("log.call-end") }}</th>
                    <td>{{ call.ets }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("log.call-status") }}</th>
                    <td>
                      <span v-if="call.status == 64" class="text-success py-1">
                        <i class="mdi mdi-phone-check"></i>
                        {{ $t("log.accept") }}
                      </span>
                      <span
                        v-if="call.status == 65"
                        class="text-secondary py-1"
                      >
                        <i class="mdi mdi-phone-minus"></i>
                        {{ $t("log.no-respon") }}
                      </span>
                      <span v-if="call.status == 67" class="text-danger py-1">
                        <i class="mdi mdi-phone-missed"></i>
                        {{ $t("log.reject") }}
                      </span>
                      <span v-if="call.status == 5" class="text-info py-1">
                        <i class="mdi mdi-phone-in-talk"></i>
                        {{ $t("log.on-call") }}
                      </span>
                      <span v-if="call.status == 1" class="text-secondary py-1">
                        <i class="mdi mdi-phone-alert"></i>
                        {{ $t("log.calling") }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("log.call-duration") }}</th>
                    <td>{{ call.duration }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import LogService from "@/helpers/log.service";
import UserService from "@/helpers/user.service";
import moment from "moment";

/**
 * Orders component
 */
export default {
  page: {
    title: "Log Activity",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { DatePicker, Layout, PageHeader },
  data() {
    return {
      title: this.$t("log.call-detail"),
      id: this.$route.params.id,
      user_type: "",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: this.$t("log.log-call"),
          href: "/log-call",
        },
        {
          text: this.$t("log.call-detail"),
          active: true,
        },
      ],
      call: {
        id: "",
        cid: "",
        gid: "",
        uid: "",
        duid: "",
        huid: "",
        ts: "",
        rts: "",
        ats: "",
        ets: "",
        type: "",
        status: "",
        sd: "",
        dd: "",
        f: "",
        user_uid: null,
        user_duid: null,
        profil_uid: null,
        profil_duid: null,
        group: null,
        duration: 0,
      },
      loading: false,
      loading_filter: false,
    };
  },
  beforeMount() {
    this.userLogin();
  },
  mounted() {
    this.detailCall();
  },
  methods: {
    userLogin() {
      UserService.listProfile()
        .then((response) => {
          this.user_type = response.data.data.role;
        })
        .catch((e) => {
          this.message = e.response.data.data;
        });
    },
    detailCall() {
      this.loading = true;
      const data = {
        id: this.id,
      };

      LogService.getDetailCall(data)
        .then((response) => {
          const val = response.data.data;
          (this.call.id = val.id),
            (this.call.cid = val.cid),
            (this.call.gid = val.gid),
            (this.call.uid = val.uid),
            (this.call.duid = val.duid),
            (this.call.huid = val.huid),
            (this.call.ts = val.ts),
            (this.call.rts = val.rts),
            (this.call.ats = val.ats),
            (this.call.ets = val.ets),
            (this.call.type = val.type),
            (this.call.status = val.status),
            (this.call.sd = val.sd),
            (this.call.dd = val.dd),
            (this.call.f = val.f),
            (this.call.user_uid = val.user_uid),
            (this.call.user_duid = val.user_duid),
            (this.call.profil_uid = val.profile_uid),
            (this.call.profil_duid = val.profile_duid),
            (this.call.group = val.group),
            (this.loading = false);
          this.getDuration(this.call.ats, this.call.ets);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getDuration(ats, ets) {
      // console.log("ats", ats);
      // console.log("ets", ets);

      let time =
        moment(ets, "YYYY-MM-DD, H:i:s").toDate() -
        moment(ats, "YYYY-MM-DD, H:i:s").toDate();
      let seconds = moment.duration(time).seconds();
      let minutes = moment.duration(time).minutes();
      let hours = moment.duration(time).hours();

      // console.log("second", minutes);

      let res = "";

      if (minutes == 0) {
        res = 0;
      }

      if (hours != 0) {
        res = hours + " hours " + minutes + " minute " + seconds + " second";
      }

      if (minutes != 0) {
        res = minutes + " minute " + seconds + " second";
      }

      if (seconds != 0) {
        res = seconds + " second";
      }

      let res2 = res.replace("-", "");
      this.call.duration = res2;
    },
  },
};
</script>
